<template>
  <div class="l-page l-page--step">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">シナリオ配信の作成</div>
        </h2>
      </div>
      <div class="l-main-content">
        <div class="p-step">
          <div class="p-step-list">
            <div class="p-step-list__item">
              <div class="c-image"><img src="/assets/img/sketch-step-01.svg" /></div>
              <div class="p-step-content">
                <div class="c-text">
                  シナリオに沿った自動配信を行います。<br />
                  プッシュ通知をクリックしたユーザーへ次のメッセージを配信するといったシナリオ配信機能が可能です。<br />
                  早速シナリオを作成して配信を行いましょう。
                </div>
              </div>
              <a class="c-btn c-btn--blue u-w244 u-h44 u-fs16 u-text-center" :href="linkData.stepAddUrl">
                <p class="c-btn__text">シナリオを作成する</p>
              </a>
            </div>
          </div>
        </div>
        <div class="p-step-result">
          <h2 class="c-title u-w600">
            <div class="c-title__text u-fs18">配信されているシナリオ一覧</div>
          </h2>
          <div class="p-step-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty}">
            <loader v-if="isLoading" />
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--abtest">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w140 is-sortable">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="deliverDate" :order="sortTargets.deliverDate" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w410 is-sortable">
                    <span class="c-table__text">シナリオ名</span>
                    <sort-switch name="scenarioName" :order="sortTargets.scenarioName" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w100">
                    <span class="c-table__text">ステップ数</span>
                  </th>
                  <th class="c-table__cell--center u-w150 is-sortable">
                    <span class="c-table__text">ステータス</span>
                    <sort-switch name="scenarioStatus" :order="sortTargets.scenarioStatus" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center"></th>
                </tr>
              </thead>
              <tbody v-if="scenarios">
                <scenario-list-item
                  v-for="(scenario,index) in scenarios.data"
                  :key="index"
                  :scenario="scenario"
                  :step-info="stepInfo"
                  @delete-click="onDeleteClick"
                  @result-click="onResultClick"
                  @review-click="onReviewClick"
                  @edit-click="onEditClick"
                  @status-change-click="onStatusChangeClick"
                />
              </tbody>
            </table>
            <pagination v-if="paginationInfo" :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />

          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="以下のシナリオを削除してもよろしいですか?"
      :body="'シナリオ : ' + currentScenarioName"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    linkData: Object,
    csrfToken: String,
    stepInfo: Object,
  },
  data () {
    return {
      sortTargets: {
        deliverDate: -1,
        scenarioName: 0,
        scenarioStatus: 0,
      },
      scenarios: null,
      paginationInfo: null,
      isLoading: false,
      isDeleteMessage: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      currentScenarioName: null,
      page: 1,
    }
  },
  mounted: function() {
    import('../../funcs/pages/step').then(module => {
      module.Step();
    });
    this.loadData();
  },
  methods: {
    loadData: function() {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      this.isLoading = true;

      // 配信状況データの取得処理実行
      axios.get('/api/scenario/list',params)
        .then(res => {
          this.scenarios = res.data.scenarios;
          this.paginationInfo = res.data.scenarios;
          setTimeout(() => {
            this.isLoading = false;
            if (res.data.scenarios.data.length < 1) this.isEmpty = true;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '設定されているABテスト一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },
    onSortButtonClick: function(target) {
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
    onDeleteClick: function(scenario) {
      this.isDeleteMessage = true;
      this.currentScenarioId = scenario.scenario_id;
      this.currentScenarioName = scenario.scenario_name;
    },
    onStatusChangeClick: function(scenario) {
      let statusTo;
      if(scenario.scenario_status == this.stepInfo.scenarioStatusValues.Wait){ // 配信中なら停止
        statusTo = this.stepInfo.scenarioStatusValues.Stop;
      } else if(scenario.scenario_status == this.stepInfo.scenarioStatusValues.Stop){ // 停止中なら配信
        statusTo = this.stepInfo.scenarioStatusValues.Wait;
      } else {
        this.isError = true;
        this.errorMessage = 'ステータスを変更できません'
        return;
      }
      // パラメタ作成
      const params = {
        scenario_id: scenario.scenario_id,
        scenario_status: statusTo,
      };
      // 削除処理実行
      axios.post('/api/scenario/setstatus',params)
        .then(res => {
          scenario.scenario_status = res.data.scenario_status;
        })
        .catch(error => {
          this.$refs.refControlModal.showErrorMessage('ステータスの変更に失敗しました');
          this.handleHttpError(error);
        });
    },
    onResultClick: function(scenarioId) {
      location.href = this.stepInfo.resultUrl + '?scenario_id=' + scenarioId;
    },
    onReviewClick: function(scenarioId) {
      location.href = '/coins-admin/step/review?scenario_id=' + scenarioId;
    },
    onEditClick: function(scenarioId) {
      location.href = this.linkData.stepAddUrl + '?type=edit&scenario_id=' + scenarioId;
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // パラメタ作成
      const params = {
        scenario_id: this.currentScenarioId,
      };

      // 削除処理実行
      axios.post('/api/scenario/delete',params)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDeleteMessage = false;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage('テストの削除に失敗しました');
          this.handleHttpError(error);
        });
    },

  }
}
</script>
